import React from 'react';
import PropTypes from 'prop-types';
import {localizedMessage} from '../message/Message';
import CardCalloutStyled from './CardCalloutStyled';

interface Props {
  title: string;
  desc?: string;
  redeemLink: string;
  imgSrc: string;
  extra?: Node;
  boxClass: string;
}

const CardCallout = ({redeemLink, title, desc, imgSrc, extra, boxClass}: Props) => {
  return (
    <CardCalloutStyled className={`card-callout-box ${boxClass}`}>
      <div className="card-callout-inner-container">
        <div className="card-callout-inner-box text-box">
          <h2>{localizedMessage(title)}</h2>
          {desc ? <p>{localizedMessage(desc)}</p> : null}
          <p>
            <a href={redeemLink} rel="noopener noreferrer" className="redeem-link">
              {localizedMessage('epic.code.redemption.posa.giftcard.go')}
            </a>
          </p>
          {extra ? extra : null}
        </div>
        <div className="card-callout-inner-box image-box">
          <img className="card-callout-image" alt="card" src={imgSrc} />
        </div>
      </div>
    </CardCalloutStyled>
  );
};

CardCallout.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  redeemLink: PropTypes.string,
  imgSrc: PropTypes.string,
  extra: PropTypes.node,
  boxClass: PropTypes.string,
};

export default CardCallout;
